<app-deprecated-modal #defaultQuestions>
    <app-segment-header title="forms.applicant-tracker.defaultApplicationQuestions"></app-segment-header>
    <img src="assets/img/applicant-tracker/default-application-questions.png" />
</app-deprecated-modal>

<form #form="ngForm" autocomplete="off">
    <ng-container>
        <app-additional-questions-card
            [jobPosting]="jobPosting"
            [questions]="additionalQuestions"
            (refreshData)="refreshData.emit()"
        ></app-additional-questions-card>

        <app-auto-archiving-questions-card
            [questions]="autoArchivingQuestions"
            (refreshData)="refreshData.emit()"
        ></app-auto-archiving-questions-card>

        <ui-card *ngIf="hasConsentFlag">
            <div class="flex justify-space-between margin-bottom-2">
                <h2>{{ 'applicant-tracker.components.consentCard.title' | translate }}</h2>
            </div>
            <div class="app-grid">
                <mat-form-field class="columns-12">
                    <ui-rich-text
                        name="applicantConsent"
                        #applicantConsent="ngModel"
                        [(ngModel)]="jobPosting.applicantConsent"
                        height="100px"
                        [stripNewlines]="true"
                        [minlength]="41"
                        [useMiniToolbar]="true"
                    ></ui-rich-text>
                    <mat-error *ngIf="applicantConsent.invalid">{{
                        'applicant-tracker.consentCharactersLimit' | translate
                    }}</mat-error>
                </mat-form-field>
            </div>
        </ui-card>
    </ng-container>
</form>
